














import Vue from 'vue'
import Fieldset from '~/components/car/classifieds/form/fieldsets/handlers/Fieldset.vue'
import BaseFieldsetMixin from '~/components/car/classifieds/form/fieldsets/handlers/BaseFieldsetMixin.vue'

export default Vue.extend({
  components: { Fieldset },
  mixins: [BaseFieldsetMixin]
})
